import React, { Component } from 'react'
import { Modal } from 'react-bootstrap';
import SelectDropDown from '../../selectdropdown/SelectDropDown';
import { components } from 'react-select'
import { getAuthorizedClassIds, filterByAuthorizedIds } from '../../../utils/authHelper';

const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
      </components.DropdownIndicator>
    )
  );
};

// ── Clean, neutral modal styles (matches the section list theme) ────────────
const ui = {
  header: { display: 'flex', alignItems: 'center', gap: 12, padding: '18px 22px', background: '#fff', borderBottom: '1px solid #f1f5f9' },
  iconWrap: { width: 40, height: 40, borderRadius: 11, background: '#f5f3ff', border: '1px solid #ddd6fe', color: '#7c3aed', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 },
  titleText: { display: 'flex', flexDirection: 'column' },
  title: { fontWeight: 800, fontSize: 17, color: '#0f172a', margin: 0, lineHeight: 1.2 },
  subtitle: { fontSize: 12, color: '#64748b', marginTop: 2 },
  close: { marginLeft: 'auto', background: 'transparent', border: 'none', color: '#94a3b8', fontSize: 24, cursor: 'pointer', lineHeight: 1, padding: 0 },
  body: { padding: '24px 22px', background: '#fff' },
  label: { display: 'block', fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 7 },
  input: { width: '100%', border: '1.5px solid #e2e8f0', borderRadius: 9, padding: '10px 12px', fontSize: 13, color: '#1f2937', background: '#fff', outline: 'none', boxSizing: 'border-box' },
  err: { fontSize: 11, color: '#ef4444', marginTop: 5 },
  success: { fontSize: 13, color: '#059669', fontWeight: 600, marginBottom: 14, background: '#ecfdf5', border: '1px solid #a7f3d0', borderRadius: 8, padding: '8px 12px' },
  apiErr: { fontSize: 13, color: '#dc2626', fontWeight: 600, marginBottom: 14, background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '8px 12px' },
  footer: { display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '14px 22px', borderTop: '1px solid #eef0f4', background: '#fff' },
  cancelBtn: { background: '#fff', color: '#64748b', border: '1.5px solid #e2e8f0', borderRadius: 10, padding: '10px 18px', fontWeight: 600, fontSize: 13, cursor: 'pointer' },
  saveBtn: { background: '#7c3aed', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 22px', fontWeight: 700, fontSize: 13, cursor: 'pointer', boxShadow: '0 6px 18px rgba(124,58,237,0.30)', display: 'inline-flex', alignItems: 'center', gap: 7 },
};

class AddSectionModalEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getbranches(data) {
    return (data || []).map(mapData => ({ value: mapData.id, label: mapData.branch_name }));
  }

  // Classes for the selected branch, sourced directly from the branch_classes
  // mapping (Branch Classes settings module). With no branch chosen, show nothing.
  // Narrowed to the classes this user is assigned (class_ids cookie); an empty
  // assignment leaves every class of the branch available.
  getClasses(branchId, branchClassMap) {
    if (!branchId) return [];
    return filterByAuthorizedIds(branchClassMap, getAuthorizedClassIds(), "class_id")
      .filter(m => String(m.branch_id) === String(branchId))
      .map(m => ({ value: m.class_id, label: m.class }));
  }

  // Stream only applies to Class 11 / Class 12 (class_id 1, 2).
  showStream(classId) {
    return String(classId) === "1" || String(classId) === "2";
  }

  // Streams whose `classes` CSV includes the selected class_id.
  getStreamOptions(classId, streams) {
    const cid = String(classId);
    return (streams || [])
      .filter(s => (s.classes || "").split(",").map(x => x.trim()).includes(cid))
      .map(s => ({ value: s.id, label: s.stream }));
  }

  render() {
    const { stateData } = this.props;
    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName="addsection-modern-modal"
      >
        {/* Header */}
        <div style={ui.header}>
          <div style={ui.iconWrap}><i className="fal fa-edit" /></div>
          <div style={ui.titleText}>
            <h5 style={ui.title}>Edit Section</h5>
            <span style={ui.subtitle}>Update the branch, class or section name</span>
          </div>
          <button type="button" style={ui.close} onClick={this.props.onHide} aria-label="Close">×</button>
        </div>

        <Modal.Body style={ui.body}>
          {stateData.currentStep == 5 ? (
            <div style={ui.success}>✓ Section updated successfully</div>
          ) : stateData.submitError ? (
            <div style={ui.apiErr}>{stateData.submitError}</div>
          ) : null}

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 18 }}>
            {/* Branch */}
            <div>
              <label style={ui.label}>Branch Name</label>
              <SelectDropDown
                name="branch"
                stateData={stateData.branchvalue}
                handleChange={this.props.parentselecthandleInputChange}
                options={this.getbranches(this.props.branches)}
                placeholderName={'BRANCH'}
                dropdownIndicator={{ DropdownIndicator }}
                isDisabled={true}
              />
            </div>

            {/* Class — branch-based */}
            <div>
              <label style={ui.label}>Class</label>
              <SelectDropDown
                name="class"
                stateData={stateData.classValue}
                handleChange={this.props.parentselecthandleInputChange}
                options={this.getClasses(
                  stateData.branch,
                  this.props.branchClassMap || []
                )}
                placeholderName={'CLASS'}
                dropdownIndicator={{ DropdownIndicator }}
                isDisabled={true}
              />
              {stateData.formErrors.class ? <div style={ui.err}>{stateData.formErrors.class}</div> : null}
            </div>

            {/* Stream — only for Class 11 / Class 12 */}
            {this.showStream(stateData.class) ? (
              <div>
                <label style={ui.label}>Stream</label>
                <SelectDropDown
                  name="stream"
                  stateData={stateData.streamvalue}
                  handleChange={this.props.parentselecthandleInputChange}
                  options={this.getStreamOptions(stateData.class, this.props.streams)}
                  placeholderName={'STREAM'}
                  dropdownIndicator={{ DropdownIndicator }}
                />
              </div>
            ) : null}

            {/* Section name */}
            <div>
              <label style={ui.label}>Section Name</label>
              <input
                type="text"
                style={ui.input}
                placeholder="SECTION"
                name="section"
                onChange={this.props.parenthandleInputChange}
                autoComplete="off"
                value={stateData.section}
              />
              {stateData.formErrors.section ? <div style={ui.err}>{stateData.formErrors.section}</div> : null}
            </div>
          </div>
        </Modal.Body>

        <div style={ui.footer}>
          <button type="button" style={ui.cancelBtn} onClick={this.props.onHide} disabled={stateData.isSaving}>Cancel</button>
          <button
            type="button"
            style={{ ...ui.saveBtn, opacity: stateData.isSaving ? 0.7 : 1, cursor: stateData.isSaving ? "not-allowed" : "pointer" }}
            onClick={this.props.parenthandleFormSubmit}
            disabled={stateData.isSaving}
          >
            {stateData.isSaving ? (
              <React.Fragment><i className="fal fa-spinner-third fa-spin" /> Updating...</React.Fragment>
            ) : (
              <React.Fragment><i className="fal fa-check" /> Update Section</React.Fragment>
            )}
          </button>
        </div>
      </Modal>
    )
  }
}

export default AddSectionModalEdit;
